import { configure } from "axios-hooks";
import Axios from "axios";
import { loginRequest, msalInstance } from "../auth/authClient";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import env from "../env";

const { REACT_APP_API_BASE_URI_VERSION } = env;

export const axiosInstance = Axios.create({
  baseURL: REACT_APP_API_BASE_URI_VERSION,
});

export const logAdminChange = async (logEntry) => {
  try {
    await axiosInstance.post("/internal/admin/log-change", logEntry, {
      baseURL: REACT_APP_API_BASE_URI_VERSION,
    });
  } catch (err) {
    console.warn("Admin logging failed", err);
  }
};

axiosInstance.interceptors.request.use(
  async (config) => {
    try {
      const acquireToken = await msalInstance.acquireTokenSilent({
        ...loginRequest,
        account: msalInstance.getAllAccounts()[0],
      });
      config.headers["Authorization"] = "Bearer " + acquireToken.accessToken;
    } catch (error) {
      console.error({ error });
      if (error instanceof InteractionRequiredAuthError) {
        // fallback to interaction when silent call fails
        await msalInstance.acquireTokenRedirect({
          ...loginRequest,
          account: msalInstance.getAllAccounts()[0],
        });
      }
    }
    return config;
  },
  (error) => {
    throw error;
  }
);

axiosInstance.interceptors.response.use(
  async (response) => {
    const method = response.config.method?.toUpperCase();
    const url = response.config.url || "";

    const isLoggingEndpoint = url.toLowerCase().includes("/internal/admin/log-change");

    const isMutation = ['POST', 'PUT', 'PATCH', 'DELETE'].includes(method) && !isLoggingEndpoint;

    if (isMutation) {
      const user = msalInstance.getAllAccounts()[0];
      const username = user?.username || "unknown";

      let dataUpdated = {};
      try {
        if (typeof response.config.data === 'string') {
          dataUpdated = JSON.parse(response.config.data);
        } else if (typeof response.config.data === 'object') {
          dataUpdated = response.config.data;
        }
      } catch (e) {
            console.warn(`"Failed to parse request data for logging"`, e);
      }

      const logEntry = {
        username,
        description: `${method} ${url}`,
        dataUpdated,
      };

      await logAdminChange(logEntry);
    }

    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

configure({
  axios: axiosInstance,
  defaultOptions: { manual: false, useCache: false, ssr: false },
});
